import { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { api } from '../api/client';

const Ctx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [portal, setPortal] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | in | out

  const refresh = useCallback(async () => {
    try { const me = await api('/portal/me'); setPortal(me); setStatus('in'); }
    catch { setPortal(null); setStatus('out'); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const me = await api('/portal/login', { method: 'POST', body: { email, password } });
    setPortal(me); setStatus('in'); return me;
  }, []);
  const logout = useCallback(async () => {
    try { await api('/portal/logout', { method: 'POST' }); } catch { /* ignore */ }
    setPortal(null); setStatus('out');
  }, []);

  return <Ctx.Provider value={{ portal, status, login, logout, refresh, setPortal, setStatus }}>{children}</Ctx.Provider>;
}

export const usePortalAuth = () => useContext(Ctx);
